import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { prettyPrintDocumentType } from "encamp-shared/src/utils/prettyPrintDocumentType";
import { Controller, useWatch, type Control } from "react-hook-form";

import type { DocumentMetadataFormData } from "../types";

import {
  currentSubmissionDocumentShown,
  hasNonCaliforniaFacility,
} from "./currentSubmissionDocument";

/**
 * "Use this document on future reports" checkbox, shown once a submission-type
 * document that is offered the choice is linked to a facility.
 */
export function CurrentSubmissionDocumentField({
  control,
}: {
  control: Control<DocumentMetadataFormData>;
}) {
  const [documentType, facilities, offerCurrentSubmissionDocument, existingCurrentSubmission] =
    useWatch({
      control,
      name: [
        "documentType",
        "facilities",
        "offerCurrentSubmissionDocument",
        "existingCurrentSubmission",
      ],
    });

  return (
    <Controller
      name="currentSubmissionDocument"
      control={control}
      render={({ field }) => {
        const checked = currentSubmissionDocumentShown({
          offerCurrentSubmissionDocument,
          currentSubmissionDocument: field.value,
          existingCurrentSubmission,
          documentType,
          facilities,
        });
        if (checked === undefined || !facilities?.length) {
          return <></>;
        }
        return (
          <FormControlLabel
            sx={{ ml: 0 }}
            control={
              <Checkbox checked={checked} onChange={(e) => field.onChange(e.target.checked)} />
            }
            label={
              <Stack>
                <Typography variant="body2">Use this document on future reports</Typography>
                <Typography variant="caption" color="text.secondary">
                  We&rsquo;ll attach it to next year&rsquo;s Tier II report automatically.
                  {hasNonCaliforniaFacility(facilities) &&
                    ` Outside California, it replaces each facility's current ${prettyPrintDocumentType(documentType)}.`}
                </Typography>
              </Stack>
            }
          />
        );
      }}
    />
  );
}
